import { FC } from 'react';
import { ViewNoteSection } from './ViewNoteSection';
import { IRecording } from '../../recording/RecordingState';
import { ICaremapNoteResponse } from '../model/NotesClient';
import { UserIcon } from '../../theme/Icons';
import { AIParticipants } from '../generic-notes/AIParticipants';
import { INote } from '../generic-notes/INote';

export const Participants: FC<{ note: ICaremapNoteResponse | INote; }> = ({ note }) => {
    const recording = note.otherAttributes?.recording as IRecording;
    return Boolean(recording?.summary?.participants?.length) && (
        <ViewNoteSection title="Participants" Icon={UserIcon} showAIIcon>
            <AIParticipants recording={recording} />
        </ViewNoteSection>
    );
};
